export default __webpack_public_path__ + "static/media/klab.61a866a9.png";